import React, { useRef } from 'react';
import BadgeCmp from 'src/components/BadgeCmp';
import TooltipCmp from 'src/components/TooltipCmp';
import TruncateTextCmp from 'src/components/TruncateText';
import { usePhone as usePhoneCommon } from 'src/utils/CommonFunctions';

const AddressDraggableCell = ({ columnName, data }: { columnName: string; data: any }) => {
    const ref = useRef<HTMLParagraphElement>(null);
    const { getFormatPhoneWithPlus } = usePhoneCommon();

    if (data === null || data === undefined) return <>-</>;

    switch (columnName) {
        case 'Name':
            return (
                <TruncateTextCmp message={data} refName={ref} tooltipType="action" truncateTextParentClassName="max-w-[150px]">
                    <p className="text-utilityBlack800 font-semibold truncate max-w-[160px]" ref={ref}>
                        {data || '-'}
                    </p>
                </TruncateTextCmp>
            );

        case 'Type':
            return (
                <div className="flex items-center gap-x-1 flex-wrap">
                    {(data || []).map((type: any, index: number) => (
                        <BadgeCmp key={index} style="modern" type={type.style}>
                            {type.label}
                        </BadgeCmp>
                    ))}
                </div>
            );

        case 'Address':
            return (
                <TruncateTextCmp message={data} refName={ref} tooltipType="action" truncateTextParentClassName="max-w-[210px]">
                    <p className="text-grayLight600 truncate max-w-[210px]" ref={ref}>
                        {data || '-'}
                    </p>
                </TruncateTextCmp>
            );

        case 'Contact Name':
            return (
                <TruncateTextCmp message={data} refName={ref} tooltipType="action" truncateTextParentClassName="max-w-[140px]">
                    <p className="text-grayLight600 truncate max-w-[140px]" ref={ref}>
                        {data || '-'}
                    </p>
                </TruncateTextCmp>
            );

        case 'Phone Number':
            return <span className="text-grayLight600 text-nowrap">{data ? getFormatPhoneWithPlus(data) : '-'}</span>;

        case 'Additional Services': {
            const count = data?.count ?? 0;
            const tooltip = data?.tooltip ?? '';

            return count > 0 ? (
                <TooltipCmp message={tooltip} position="top">
                    <BadgeCmp style="modern" type="gray" isHidePillDot>
                        {count}
                    </BadgeCmp>
                </TooltipCmp>
            ) : (
                <span className="text-grayLight600">-</span>
            );
        }

        default:
            return <>-</>;
    }
};

export default AddressDraggableCell;
